// extracted by css-extract-rspack-plugin
module.exports =  {"flipContainer":"aLR8l","cardWrap":"TmLRB","flip":"fsVWr","flipCard":"KcSNf","cardFront":"Ggkl8","cardBack":"JhigC"};